<template>
  <div>
    <div class="break-all text-xs font-medium leading-none text-gray-500 md:text-base">
      <div data-test="dashboard-title-activityfeed">
        <slot />
      </div>
    </div>
  </div>
</template>
